import React from "react";
import "../css/DayLinks.css";

const driveLinks = [
  { day: "दिवस 1", link: "https://photos.google.com/share/AF1QipOT8Te-05dMZzg0RVaRQuJRNww292FmG0VS3nGpoSooiffiE6tlOGPxKHZeHHQW9A?key=RXRpREg4aDBfTFB4OXFWQ2NZclpKa1dGNk9mUWFB" },
  { day: "दिवस 2", link: "https://photos.google.com/share/AF1QipPQm8Xe4rzx4JtsG3ZDMYl2GuZNj8YG6ldZrJrQxk1Ou7WWAhOr2oPVMCywcwKCPw?key=WTBCampVWmg2cElJX0NPNkQyMmRPT05NbjlIMWN3" },
  { day: "दिवस 3", link: "https://photos.google.com/share/AF1QipM8_UxfLXmOOhr64ShWOheWGLC6IPNIQ9CJrZkTxJv0uc_iRmftcjxmAPLwiYUGng?key=cTI0T0doSlptajg4TXQxN1FYYllWMEtuajluNGJ3" },
  { day: "दिवस 4", link: "https://photos.google.com/share/AF1QipO3PooeLBiEsWTYNrOGk6tujl31NQfNLLmeYb0SzUjNneVFslqp85ktLK7CwPFqHg?key=dEhrOHNVZFdyYl9sM29sZldaZzVGSmlmMHpxWkV3" },
  { day: "दिवस 5", link: "https://photos.google.com/share/AF1QipPIHIBaH3fCigA6qftFW2jpng4eyH9KxIdNqmwtOueNhqU_D3rvKAfnir5KSFtEMw?key=QXRYRkprbDBxVmM1akdfeUpoTEtkQXNJcF9MQnBn" },
  { day: "दिवस 6", link: "https://photos.google.com/share/AF1QipMT4XfxzbgLGq1lKexjG5iQhDOG8jmvcatLBVJb6LIussoSmRNadwLK7B__vEozvA?key=TVpRZk9KaTZHSzJCUUFiRFVrLUN6NmtLVTEza0Zn" },
  { day: "दिवस 7", link: "https://photos.google.com/share/AF1QipMo0z9eck6U6HZgMgM-Uz0BHqUv6ZRt0hAOhMIAyMP5LpKL10JV086mnBnVnK9c0w?key=QnduUzVSWGEydUtXcWZBZTE2eHhrLTNhT0RCWDlB" },
  { day: "दिवस 8", link: "https://photos.google.com/share/AF1QipO2ObQQuCwRb8AX_x7kisqyTqvOg8gAAdBsJ3iljVeNAFlEfdUAgBQZVWEa-7iIsQ?key=UV9SVndJMjhnZDFzU2ZrNGIyNTJ2a19FbkhyRzNR" },
];

const DayLinks = () => {
  const handleClick = (link) => {
    window.open(link, "_blank"); // Opens the link in a new tab
  };

  return (
    <div className="day-links-container">
      <h1>रौप्य महोत्सव २०२५ </h1><br />
      <p>श्रीसद्गुरु वेंकटेश दाजीमहाराजांचा १६५वा जन्मोत्सव तसेच सच्चिदानंद वेद स्वाध्याय प्रतिष्ठानचा रोप्य महोत्सवी कार्यक्रमा संदर्भातील छायाचित्रांची गुगल ड्राईव्हची लिंक आपणास शेअर करत आहोत. हे छायाचित्र आठ दिवसाच्या विविध कार्यक्रमांचे आहेत आपण तिथे क्लिक करून छायाचित्रे बघू शकता.</p>
      <div className="day-links-grid">
        {driveLinks.map((item, index) => (
          <button
            key={index}
            onClick={() => handleClick(item.link)}
            className="day-button"
          >
            {item.day}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DayLinks;
